<template>
  <section>
    <h3>{{ $t('message.menu.my_reservations') }}</h3>
    <div id="content">
      <nav class="nav nav-tabs nav-justified">
        <a class="nav-item nav-link"
           :class="[(currentTab === 'upcoming') ? 'active' : '']"
           href="#upcoming"
           @click.prevent="showMyOrders('upcoming')">
          {{ $t('message.my_reservations.upcoming') }}
        </a>
        <a class="nav-item nav-link"
           :class="[(currentTab === 'past') ? 'active' : '']"
           href="#past"
           @click.prevent="showMyOrders('past')">
          {{ $t('message.my_reservations.past') }}
        </a>
      </nav>
      <div id="my-tab-content" class="tab-content">
        <order-list ref="orders" :status="currentTab" />
        <!--
        <div class="tab-pane active" id="upcoming">
          <order-list ref="upcoming" :status="'upcoming'" />
        </div>
        <div class="tab-pane" id="past">
          <order-list ref="past" :status="'past'" />
        </div>
        -->
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import OrderList from './Orders.vue'

  export default {
    components: {
      OrderList
    },
    data () {
      return {
        currentTab: 'upcoming'
      }
    },
    computed: {
      ...mapGetters({
        state: 'order/getState'
      })
    },
    methods: {
      showMyOrders (type) {
        this.$store.commit('order/SET_CURRENT_ORDER_TYPE', type)
        this.setCurrentTab(type)
        this.$refs.orders.initialData(type)
      },
      setCurrentTab (tab) {
        this.currentTab = tab
      }
    },
    mounted () {
      let currentOrderType = 'upcoming'
      if (this.state.currentOrderType) {
        currentOrderType = this.state.currentOrderType
      }
      this.showMyOrders(currentOrderType)
    }
  }
</script>

<style scoped>
  .nav-tabs > a.nav-item , a.active:after {
    display: block;
    padding: 0;
    height: 4px;
    background-color: #00ACC1;
    content: ' ';
    width: 100%;
    margin: 0 auto;
    margin-top: 13px;
  }

  .nav-tabs > a.nav-item {
    background: none;
    border: 0;
    padding: 0;
  }

  .nav-tabs > a.nav-item {
    border-bottom: 1px solid #DDD;
  }

  @media (max-width: 768px) {
    .nav-justified > li {
      display: table-cell;
      width: 1%;
    }

    .nav-justified > li > a {
      border-bottom: 1px solid #DDD;
      border-radius: 0;
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/MyOrders.vue